import {
  useGetCaseSLAConfigurations,
  useGetCategories,
} from "@vega-api/generated/case-admin-v1/case-admin-v1";
import { StatusTag } from "@vega-core/components/StatusTag/StatusTag";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { NewCategoryForm } from "../NewCategoryForm/NewCategoryForm";

import { CategoryActiveToggle } from "./CategoryActiveToggle";
import { EditCategoryButton } from "./EditCategoryButton";

export const CategoriesSettingsCard = () => {
  const { data: categoriesData } = useGetCategories({ page: 1 });
  const { data: slaData } = useGetCaseSLAConfigurations({ page: 1 });

  const categories = categoriesData?.data.categories ?? [];

  const categorySlaHours = new Map<string, number>();
  (slaData?.data?.slaConfigurations ?? []).forEach((config) => {
    if (!config.caseTypeId) {
      categorySlaHours.set(config.categoryId, config.slaInHours);
    }
  });

  return (
    <div className="space-y-6" data-testid="categories-settings-card">
      <div className="flex justify-end">
        <NewCategoryForm />
      </div>

      <section className="rounded-companyBorderRadius border border-border/primary p-6">
        {categories.length === 0 ? (
          <p
            className="body-base-regular text-text/secondary"
            data-testid="categories-empty"
          >
            {m.cases_settings_categories_empty()}
          </p>
        ) : (
          <ul
            className="divide-y divide-border/primary"
            data-testid="categories-list"
          >
            {categories.map((category) => {
              const isInactive = category.status === "INACTIVE";
              const slaHours = categorySlaHours.get(category.id);

              return (
                <li
                  className="flex items-center justify-between gap-4 py-3"
                  data-testid={`category-row-${category.id}`}
                  key={category.id}
                >
                  <div className="min-w-0 flex items-center gap-3">
                    <div className="min-w-0">
                      <p
                        className={cnTwMerge(
                          "body-base-medium truncate",
                          isInactive && "text-text/secondary",
                        )}
                      >
                        {category.name}
                      </p>
                      {category.description ? (
                        <p className="body-small-regular text-text/secondary truncate">
                          {category.description}
                        </p>
                      ) : null}
                    </div>
                    {isInactive ? (
                      <StatusTag
                        dataTestId={`category-inactive-badge-${category.id}`}
                        status="CLOSED"
                      >
                        {m.cases_settings_category_inactive()}
                      </StatusTag>
                    ) : null}
                  </div>

                  <div className="flex items-center gap-4">
                    <span
                      className="body-base-medium"
                      data-testid={`category-sla-${category.id}-value`}
                    >
                      {slaHours === undefined
                        ? "—"
                        : m.cases_settings_hoursSuffix({ hours: slaHours })}
                    </span>
                    <EditCategoryButton
                      category={category}
                      slaHours={slaHours}
                    />
                    <CategoryActiveToggle category={category} />
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </section>
    </div>
  );
};
